import React from "react";
import GetUserInfoService from "../../../service/GetUserInfoService";
import { useHistory } from "react-router-dom";

const ListElement = (props) => {
  const { notification } = props;
  const history = useHistory();

  const getUserInfoService = new GetUserInfoService();

  const readNotification = async () => {
    await getUserInfoService.postUserNotifications(
      localStorage.getItem("__extraconomy_token"),
      localStorage.getItem("__extraconomy_username"),
      notification.id
    );
    const url = notification.parameters[0].valueparameter?.replace(
      "https://www.extraconomy.com",
      ""
    );

    history.push(url);
  };

  return (
    <div
      style={{
        width: "100%",
        minHeight: "50px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "15px",
        borderBottom: "2px solid #272360",
        cursor: "pointer",
      }}
      onClick={(e) => {
        e.preventDefault();
        readNotification();
      }}
    >
      <div className="flex align-items-center justify-content-between w-full">
        <h2 className="text-lg relative m-0">
          {notification.titleDeviceMessage}
          <p
            className="absolute"
            style={{
              position: "absolute",
              right: "-10px",
              top: "-2px",
              width: "10px",
              height: "10px",
              borderRadius: "18px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 5,
              backgroundColor: "#D32F2F",
              color: "white",
            }}
          />
        </h2>

        <i className="pi pi-arrow-right" />
      </div>

      <p className="text-left">{notification.deviceMessage}</p>
    </div>
  );
};

export default ListElement;
